import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';

import {
  calculateWidthHeightConfiguration,
  calculateWidthHeightPrismaXS,
  getEnclosureDimensionsBasedOnZoomFactor,
} from '../../prisma-xs/helpers/elements-sizes-calculations.helper';
import { Enclosure } from '../../prisma-xs/models/prisma-xs.model';
import { MAX_FIELD_ENCLOSURE_SIZE, MIN_FIELD_ENCLOSURE_SIZE } from '../../enclosure/models/enclosure.constants';
import { PrismaXsConstant } from '../../shared/models/prisma-xs.constant';

@Directive({
    selector: '[appGrid]',
    standalone: false
})
export class GridDirective implements AfterViewInit {
  @Input() rows: number;
  @Input() cols: number;
  @Input() zoomLevel: number;
  @Input() configurationType: 'PrismaXS'|'PMC';
  @Input() enclosure: Enclosure;
  @Input() parentDiv: HTMLElement;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    const { width, height } = getEnclosureDimensionsBasedOnZoomFactor(
      this.parentDiv,
      this.zoomLevel,
      this.enclosure.configurationRows,
      this.enclosure.configurationFields,
      this.rows,
      this.cols);

    // eslint-disable-next-line max-len
    let { enclosureHeight, enclosureWidth } = calculateWidthHeightConfiguration(
      width,
      height,
      this.configurationType,
      this.enclosure.configurationRows,
      this.enclosure.configurationFields);
    const heightOfOneField = enclosureHeight / this.rows;
    if (heightOfOneField < MIN_FIELD_ENCLOSURE_SIZE) {
      // TODO check can this be removed
      const enclosureMinDimensions = calculateWidthHeightConfiguration(
        MIN_FIELD_ENCLOSURE_SIZE * PrismaXsConstant.GRID_BOX_PROPORTION * this.enclosure.configurationFields,
        MIN_FIELD_ENCLOSURE_SIZE * this.enclosure.configurationRows,
        this.configurationType,
        this.enclosure.configurationRows, this.enclosure.configurationFields);
      enclosureHeight = enclosureMinDimensions.enclosureHeight;
      enclosureWidth = enclosureMinDimensions.enclosureWidth;
    }
    if (heightOfOneField > MAX_FIELD_ENCLOSURE_SIZE) {
      const enclosureMinDimensions = calculateWidthHeightPrismaXS(
        MAX_FIELD_ENCLOSURE_SIZE * this.rows, this.enclosure.configurationRows, this.enclosure.configurationFields);
      enclosureHeight = enclosureMinDimensions.enclosureHeight;
      enclosureWidth = enclosureMinDimensions.enclosureWidth;
    }

    this.renderer.setStyle(this.el.nativeElement, 'height', `${ enclosureHeight }px`);
    this.renderer.setStyle(this.el.nativeElement, 'width', `${ enclosureWidth }px`);
  }
}

